<template>
  <div class="vacancy-fixed-panel  container" :class="elClass">
    <div class="vacancy-fixed-panel__content  container-inner">
      <div class="vacancy-fixed-panel__btns  vacancy-btns">
        <VacancyMainBookmarksBtn :inBookmarks="vacancy.in_bookmarks"
                                 :pending="pendingBookmarks"
                                 @toggle="$emit('toggle-bookmarks')"
                                 class="vacancy-btns__btn  _bookmarks"/>
        <VacancyMainRespondBtn :vacancy="vacancy"
                               small
                               class="vacancy-btns__btn  _respond"/>
      </div>
      <VacancyActual :vacancy="vacancy"
                     class="vacancy-fixed-panel__actual"/>
    </div>
  </div>
</template>

<script>
  import windowSizeMixin from '../../mixins/windowSizeMixin';
  import VacancyMainBookmarksBtn from './VacancyMainBookmarksBtn'
  import VacancyMainRespondBtn from './VacancyMainRespondBtn'
  import VacancyActual from './VacancyActual'

  export default {
    name: 'VacancyFixedPanel',
    components: {
      VacancyMainBookmarksBtn,
      VacancyMainRespondBtn,
      VacancyActual,
    },
    mixins: [windowSizeMixin],
    props: ['vacancy', 'pendingBookmarks'],
    data() {
      return {
        show: false,
      };
    },
    computed: {
      elClass() {
        if (!this.smOrDown) return '';

        return this.show ? 'd-block' : 'd-none';
      },
    },
    mounted() {
      document.addEventListener('scroll', this.onScroll);
      this.onScroll();
    },
    beforeDestroy() {
      document.removeEventListener('scroll', this.onScroll);
    },
    methods: {
      onScroll() {
        if (this.smOrDown) {
          this.checkBlockVisibility();
        }
      },
      checkBlockVisibility() {
        const similarVacanciesHeaderSpacing = 100;
        const rect = document.querySelector('.vacancy-page__similar-vacancies-list')?.getBoundingClientRect();
        if (!rect) return;
        const similarVacanciesVisibility = Math.round(rect.top - (window.innerHeight - similarVacanciesHeaderSpacing));
        this.show = similarVacanciesVisibility > 0;
      },
    },
  }
</script>

<style lang="less">

</style>
